<template>
    <v-flex>
        <div style="height: 400px !important;">
        <v-layout row class="content-header">
            <v-flex md4 class="content-title">
                <h2>Emissão de Notas</h2>
                <h4>Use os filtros para listar as notas que deseja visualizar/enviar</h4>
            </v-flex>
            <v-layout row wrap class="text-right">
                <v-row class="text-right">
                    <v-col cols="7">
                        &nbsp;
                    </v-col>
                    <v-col cols="3">
                        <v-select :items="Periodos" item-text="Periodo" v-model="PeriodoSelecionado" item-value="Termo" label="Competência" @change="SelecionarPeriodo" outlined></v-select>                        
                    </v-col>
                    <v-col cols="2">
                        &nbsp;<v-btn color="info" style="margin-top:0px !important;" @click="BaixarPDF()" title="Download"><v-icon dark>mdi-cloud-download</v-icon></v-btn>             
                    </v-col>                    
                </v-row>
                <br>
            </v-layout>
            <v-flex md12>
            </v-flex>
            <v-flex md12>
                <div class="line"></div>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="comissoes"
                    :items-per-page="topItems"
                    :loading="loading"
                    :options.sync="options"
                    loading-text="Carregando... Por favor aguarde."
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"   
                    :single-select="false"
                    show-select                      
                    justify="center">
                    <template v-slot:top class="text-right">
                        <v-switch label="Marcar Todos" v-model="MarcarTodos" @change="FuncaoMarcarTodos()" :disabled="TodosRecibos.length == 0"></v-switch>
                    </template>
                    <template v-slot:header.data-table-select="{ item }">
                        Enviar
                    </template>
                    <template v-slot:item.data-table-select="{ item }">
                        <v-layout justify-center>
                            <span class="alert" v-if="item.recebida == true">NF Enviada</span>
                            <v-checkbox primary hide-details class="m-0" v-if="item.recebida == false" :value="item.numeroRecibo" v-model="Recibos"></v-checkbox>                            
                        </v-layout>
                    </template>                    
                    <template v-slot:item.dataPagamento="{ item }">
                        {{ FormatarData(item.dataPagamento) }}
                    </template>
                    <template v-slot:item.tipoComissao="{ item }">
                        <span v-if="item.tipoComissao == 'COR'">Corretagem</span>
                        <span v-if="item.tipoComissao == 'AGE'">Agenciamento</span>
                    </template> 
                    <template v-slot:item.valorBruto="{ item }">
                        {{ FormatarValorMonetario(item.valorBruto) }}
                    </template>                     
                    <template v-slot:item.impostoRendaRetido="{ item }">
                        {{ FormatarValorMonetario(item.impostoRendaRetido) }}
                    </template>
                    <template v-slot:item.valorInss="{ item }">
                        {{ FormatarValorMonetario(item.valorInss) }}
                    </template>                                 
                    <template v-slot:item.valorIss="{ item }">
                        {{ FormatarValorMonetario(item.valorIss) }}
                    </template>                            
                    <template v-slot:item.valorLiquido="{ item }">
                        {{ FormatarValorMonetario(item.valorBruto - ( item.impostoRendaRetido + item.valorInss + item.valorIss ))  }}
                    </template>                     
                </v-data-table>
                <br>
                <v-layout justify-end>
                    <v-dialog v-model="showForm" persistent max-width="1000px">
                        <template v-slot:activator="{ on }">
                        <v-btn color="info" v-on="on" @click="showForm = true" :disabled="HabilitarEnvio()">
                            <v-icon>mdi-arrow-up</v-icon>
                            Enviar Nota Fiscal
                        </v-btn>
                        </template>
                        <v-form @submit.prevent="EnviarNotaFiscal('formNotaFiscal')" data-vv-scope="formNotaFiscal" ref="formNotaFiscal" >
                        <v-card>
                            <v-overlay :value="fullLoading">
                                <v-progress-circular indeterminate size="64"></v-progress-circular>
                            </v-overlay>                      
                            <v-card-title>
                            <span class="headline">Dados da Nota Fiscal</span>
                            </v-card-title>
                            <v-card-text>
                                <v-divider></v-divider>
                                <div>
                                    <v-layout row wrap>
                                        <v-flex xs12 md5>
                                            <v-file-input v-model="Arquivo" show-size accept="application/pdf" label="Arquivo da Nota Fiscal" :rules="[rules.required, rules.file]" tabindex="1"></v-file-input><br />
                                        </v-flex>
                                    </v-layout>
                                    <v-layout wrap justify-space-between>
                                        <v-flex xs12 md5>
                                            <v-text-field v-model="NumeroNota" label="Número da Nota" :rules="[rules.required]" tabindex="2"></v-text-field>
                                            <v-text-field v-model="Irrf" label="IRRF" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="4"></v-text-field>
                                            <v-text-field v-model="Iss" label="ISS" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="6"></v-text-field>                                        
                                        </v-flex>
                                        <v-flex xs12 md5>                                
                                            <v-text-field v-model="ValorBruto" label="Valor Bruto" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="3"></v-text-field>
                                            <v-text-field v-model="Inss" label="INSS" v-formatMoney="money" return-masked-value :rules="[rules.required]" tabindex="5"></v-text-field>
                                            <v-text-field v-model="ImpostoTotal" v-formatMoney="money" return-masked-value label="Imposto Total" :rules="[rules.required]" tabindex="7"></v-text-field>
                                        </v-flex>                                
                                    </v-layout>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" text type="button" @click="showForm = false">Cancelar</v-btn>
                            <v-btn color="green" text type="submit" tabindex="8">Enviar</v-btn>
                            </v-card-actions>
                        </v-card>      
                        </v-form>
                    </v-dialog>             

                    <v-overlay :value="fullLoading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-layout>     
                <br>
            </v-flex>
        </v-layout>               
        </div>        
    </v-flex>
</template>

<script>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex';
import Helpers from "@/utilities/Helpers";

    export default {  
        mixins: [Helpers],      
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                PeriodoId : 1,
                PeriodoSelecionado : "",
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 1000,
                offset: 1,
                options: {},               
                Periodos: [],                                             
                headers: [
                    //{text: "", value: "numeroRecibo", sortable: false},
                    {text: "Pagamento", value: "dataPagamento", sortable: false},
                    {text: "Tipo", value: "tipoComissao", sortable: false},
                    {text: "Valor Bruto (R$)", value: "valorBruto", sortable: false},
                    {text: "IRRF (R$)", value: "impostoRendaRetido", sortable: false},
                    {text: "INSS (R$)", value: "valorInss", sortable: false},
                    {text: "ISS (R$)", value: "valorIss", sortable: false},
                    {text: "Líquido (R$)", value: "valorLiquido", sortable: false},
                ],
                comissoes: [],
                Recibos: [],
                TodosRecibos: [],                
                MarcarTodos: false,
                showForm: false,
                Arquivo : null,
                NumeroNota : null,
                ValorBruto : null,
                Irrf : null,
                Inss : null,
                Iss : null,
                ImpostoTotal : null,
                rules: {
                    required: value => !!value || 'Obrigatório',
                    file: value => !value || value.size < 20000000 || 'Obrigatório',
                },
                money: {
                    prefix: "",
                    suffix: "",
                    thousands: ".",
                    decimal: ",",
                    precision: 2
                },                
            }
        }, 
  methods: {
      FuncaoMarcarTodos()
      {
          if(this.MarcarTodos == true)
            this.Recibos = this.TodosRecibos;
          else
            this.Recibos = [];
      },
      CarregarPeriodo()
      {
          for(let i = 0;i < 24;i++)
          {
            const _hoje = new Date();   
            if (_hoje.getDate() == 31) 
                _hoje.setDate(1);              
                
            const _data = new Date(_hoje.setMonth(_hoje.getMonth()-i));
            _data.setHours(0, 0, 0);
            _data.setMilliseconds(0);               

              this.Periodos.push({ Id : i+1, Periodo : this.Meses[_data.getMonth()]+"/"+_data.getFullYear(), Termo : _data.getFullYear()+"-"+this.Meses[_data.getMonth()] });
          }
          this.PeriodoSelecionado = this.Periodos.find(obj => obj.Id == this.PeriodoId).Termo;
      },
      CarregarComissao()
      {
            this.fullLoading = true;

            this.comissoes = [];
            this.MarcarTodos = false;
            this.TodosRecibos = [];
            this.Recibos = [];            
            this.loading = true;
            let top = this.topItems;
            let skip = (this.offset * top) - top;
            let codigoCorretor = this.usuario.codCorretor;
            console.log("recibo-s");
            let url = "ResumoPagamentoComissao/Recibos/"+codigoCorretor+"/"+this.PeriodoSelecionado;
            console.log(url);
            Vue.prototype.$httpPortal.get(url)
            .then(res => {
                this.comissoes = res.data;
                console.log(res.data);
                this.loading = false;
                this.fullLoading = false;
                for(const key in this.comissoes) {
                    if (this.comissoes[key].recebida == false)
                    {
                        this.TodosRecibos.push(this.comissoes[key].numeroRecibo);
                    }
                } 
                console.log("this.TodosRecibos");
                console.log(this.TodosRecibos);
            })
            .catch(ex => {
                console.log(ex);
                this.showToast("error", "Erro", "Ocorreu um problema no carregamento");
                this.loading = false;
                this.fullLoading = false;
            }); 
      },
      SelecionarPeriodo(value)
      {
           this.PeriodoSelecionado = value;
           this.CarregarComissao();
      },
      BaixarPDF()
      {
        let codigoCorretor = this.usuario.codCorretor;
        let url = this.baseURL + "Emissao/ResumoComissao/" + codigoCorretor+"/"+ this.PeriodoSelecionado;

        window.open(url, "_blank");             
      },
      FormatarValorMonetario(valor)
      {
          return valor.toLocaleString('pt-br', {minimumFractionDigits: 2});
      },
      MascaraValorMonetario(evento)
      {
        let _valor = evento.target.value;
        _valor = isNaN(_valor.replace(",", "").replace(".", "")) || _valor.length == 0 ? 0 : _valor;
        _valor = _valor + '';
        _valor = parseInt(_valor.replace(/[\D]+/g,''));
        _valor = _valor + '';
        _valor = _valor.replace(/([0-9]{2})$/g, ",$1");

        if (_valor.length > 6) {
            _valor = _valor.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
        }            
        evento.target.value = _valor;              
      },      
      EnviarNotaFiscal(scope)
      {
          if (this.Recibos.length > 0)
          {
            if(this.$refs.formNotaFiscal.validate())
            {
                this.fullLoading = true;
                //this.showForm = false;

                let codigoCorretor = this.usuario.codCorretor;
                let idUsuario = this.usuario.Id;
                let emailUsuario = this.usuario.email;

                let formData = new FormData();
                formData.append('CodigoCorretor', codigoCorretor);
                formData.append('IdUsuario', codigoCorretor);
                formData.append('EmailUsuario', emailUsuario);
                formData.append('NumeroNota', this.NumeroNota);
                formData.append('ValorBruto', this.ValorBruto);
                formData.append('Irrf', this.Irrf);
                formData.append('Inss', this.Inss);
                formData.append('Iss', this.Iss);
                formData.append('ImpostoTotal', this.ImpostoTotal);
                for (let i = 0; i < this.Recibos.length;i++)
                {
                    formData.append('Recibo', this.Recibos[i]);
                }
                
                formData.append('Arquivo', this.Arquivo);

                 Vue.prototype.$httpPortal.post("NotaFiscal", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                ).then(res => {
                    console.log(res.data);
                    if(res.data.length > 0)
                    {
                        this.showToast("error", "Erro", res.data);
                    }
                    else
                    {
                        this.showToast("success", "Sucesso", "Nota Fiscal Enviada!");
                    }

                    this.FinalizarEnvioNotaFiscal();
                })
                .catch(res => {
                    this.showToast("error", "Erro", "Falha no envio da Nota Fiscal");
                    console.log(res);
                    this.FinalizarEnvioNotaFiscal();
                });                 
            }
          }
          else
          {
              console.log("recibo-s não selecionados");
          }
      },
      FinalizarEnvioNotaFiscal()
      {
        this.fullLoading = false;
        this.showForm = false;
        this.Recibos = [];
        this.$refs.formNotaFiscal.reset();
        this.$refs.formNotaFiscal.resetValidation();
        this.CarregarComissao();     

      },
      HabilitarEnvio() 
      {
        if(this.Recibos.length > 0)
          return false;
        else
          return true;
      },      
  },
    watch: {
            options(value){
                const _lista = this.Recibos;
                this.Recibos = [];
                for(let index in _lista)
                {
                    this.Recibos.push(_lista[index]);
                }
            }             
    },        
    computed: {
    ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
    },
    mounted(){            
        this.CarregarPeriodo();
        this.CarregarComissao();
    },          

    }
</script>
